module.exports = __webpack_public_path__ + "static/media/Chloroform_Room_Start.f449c9dc.mp3";